import { ConfigurationType } from 'apps/keba-wallbox-app/src/plugins/keba-wallbox-plugin';

import { FirmwareVersions } from 'libs/common/utils';
import { FormInputType, SettingsFormData } from '../../components';
import { WallboxProductCodeRegex } from '../../utils/WallboxRegexes';
import { WallboxConnectionType } from '../wallbox-connection-type.definition';
import { ClusterKey } from '../cluster.definition';

export const clusterFormDefinition: SettingsFormData[] = [
  {
    elements: [
      {
        key: ClusterKey.CLUSTERS_ENABLE,
        type: FormInputType.TOGGLE,
        description: 'kw.settings.cluster-settings.use_cluster.description',
        title: 'kw.settings.cluster-settings.use_cluster.title',
        configurationType: ConfigurationType.LMGMT,
        listenOnChanges: true,
        hideConditions: {
          operator: 'or',
          conditions: [
            {
              operator: 'and',
              conditions: [
                { condition: 'firmwareVersionsBelow', value: FirmwareVersions.P40_1_0_5 },
                { condition: 'productCode', value: WallboxProductCodeRegex.IS_P40 },
                { condition: 'connectionType', value: WallboxConnectionType.LOCAL_REST },
              ],
            },
            {
              operator: 'and',
              conditions: [
                { condition: 'firmwareVersionsBelow', value: FirmwareVersions.P40_1_0_5 },
                { condition: 'productCode', value: WallboxProductCodeRegex.IS_P40 },
                { condition: 'connectionType', value: WallboxConnectionType.REMOTE },
              ],
            },
            {
              operator: 'and',
              conditions: [
                { condition: 'productCode', value: WallboxProductCodeRegex.IS_P40 },
                { condition: 'connectionType', value: WallboxConnectionType.LOCAL_BLE },
              ],
            },
          ],
        },
        accessibilityId: 'enable-cluster',
      },
      {
        key: 'chargepoint-cluster-table',
        title: '',
        type: FormInputType.CUSTOM,
        hideElement: false,
        showDependentOnOtherSetting: {
          [ClusterKey.CLUSTERS_ENABLE]: 'true',
        },
      },
    ],
  },
];
